import React from "react";
import { Icon, IconProps } from "../Icon";
/**
 * @group Icons
 */
export function MusicVideoIcon(props: IconProps) {
    return <Icon {...props} iconKey={"music_video"}/>
}
